import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';

interface NotificationData {
  title: string,
  type: 'INFO' | 'ERROR' | 'WARNING' | 'NOTICE',
  app: string,
  client: string,
  visibleFrom: number | null,
  visibleTo: number | null,
  status: 'ACTIVE' | 'INACTIVE',
  message: string,
  url: string
}

@Component({
  selector: 'app-notification-bar-form',
  templateUrl: './notification-bar-form.component.html',
  styleUrls: ['./notification-bar-form.component.scss']
})
export class NotificationBarFormComponent implements OnInit {
  @Input('initialData') initialData;
  @Input('types') types;
  @Input('apps') apps;
  @Input('organizations') organizations;
  @Input('isModal') isModal: boolean = false;

  @Output() buttonClicked = new EventEmitter();

  notificationData: NotificationData = {
    title: '',
    type: 'INFO',
    app: '',
    client: '',
    visibleFrom: null,
    visibleTo: null,
    status: 'ACTIVE',
    message: '',
    url: ''
  };

  dates = {
    visibleFrom: {
      date: '',
      time: ''
    },
    visibleTo: {
      date: '',
      time: ''
    }
  }

  endDate: Date;

  constructor() { }

  selectedDate: Date;
  selectedTime: string;
  epochTimestamp: number;


  ngOnInit() {
    if (this.initialData) {
      this.notificationData = { ...this.initialData };

      for (let key of Object.keys(this.dates)) {
        if (this.initialData && this.initialData[key]) {
          const date = new Date(this.initialData[key] * 1000);
          this.dates[key].date = date;
          this.dates[key].time = this.formatTime(date);
        }
      }
    }
  }

  convertToEpoch(): void {
    for (let key of Object.keys(this.dates)) {
      if (this.dates[key].date && this.dates[key].time) {
        const [hours, minutes] = this.dates[key].time.split(':').map(Number);
        const date = new Date(this.dates[key].date);
        date.setHours(hours, minutes);
        const timestamp = Math.floor(date.getTime() / 1000);
        this.notificationData[key] = timestamp;
      }
    }
  }

  formatTime(date: Date): string {
    const hours = this.padWithZeroes(date.getHours().toString(), 2);
    const minutes = this.padWithZeroes(date.getMinutes().toString(), 2);
    return `${hours}:${minutes}`;
  }

  padWithZeroes(str: string, targetLength: number): string {
    return ('0'.repeat(targetLength) + str).slice(-targetLength);
  }

  save(form: NgForm): void {
    const dataToEmit = { ...this.notificationData };

    if (dataToEmit.url === '') {
      dataToEmit.url = null;
    }

    this.buttonClicked.emit({ mode: 'create', data: dataToEmit });
    form.resetForm();
  }

  previewOrClose(): void {
    const emitValue = this.isModal ? 'close' : { mode: 'preview', data: this.notificationData };
    this.buttonClicked.emit(emitValue);
  }

  createPreview(): void {
    const previewData = { ...this.notificationData };
    previewData.visibleFrom = Date.now();
    previewData.visibleTo = (Date.now() + 100000);
  }

  validateDates(form: NgForm): void {
    this.convertToEpoch();

    const controls = ['visibleFromDate', 'visibleFromTime', 'visibleToDate', 'visibleToTime'];
    if (this.notificationData.visibleFrom && this.notificationData.visibleTo && (this.notificationData.visibleFrom >= this.notificationData.visibleTo)) {
      controls.forEach(control => {
        const errors = form.controls[control].errors || {};
        form.controls[control].setErrors({ ...errors, dateInvalid: true });
      });
    } else {
      controls.forEach(control => {
        const errors = form.controls[control].errors || {};
        const { dateInvalid, ...remainingErrors } = errors;
        form.controls[control].setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/notification-bar-editor/notification-bar-form/notification-bar-form.component.ts